import Html from 'Component/Html';
import NotificationIconComponent from 'Component/NotificationIcon';
import {
    NotificationComponent as SourceNotificationComponent,
} from 'SourceComponent/Notification/Notification.component';
import {ReactElement} from 'Type/Common.type';
import { scrollToTop } from 'Util/Browser';

/** @namespace Steinkrueger/Component/Notification/Component */
export class NotificationComponent extends SourceNotificationComponent {
    render(): ReactElement {
        const { notification, id } = this.props;
        const { isNotificationVisible } = this.state;
        const { msgText, msgType } = notification;
        const isAbsolutePosition = location.pathname === '/' || location.pathname === '/blog';

        const mods = {
            type: msgType.toLowerCase(),
            is: isNotificationVisible ? 'opening' : 'closing',
            position: isAbsolutePosition ? 'absolute' : 'relative',
        };

        scrollToTop();

        return (
            <div block="Notification" mods={ mods } ref={ this.notification } id={ id }>
                <p block="Notification" elem="Text">
                    <NotificationIconComponent type={ mods.type } />
                    <Html content={ __(msgText) } />
                </p>
                { this.renderDebug() }
            </div>
        );
    }
}

export default NotificationComponent;
